<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('friends-updates')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Edit Friends Updates</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <b-form-group label="Title">
          <base-input
            alternative
            class="mb-3"
            name="Title"
            :rules="{ required: true }"
            placeholder="Title"
            v-model="title"
          >
          </base-input>
        </b-form-group>
        <b-form-group
          label="Friends Update image (max size 5MB and Dimensions should H-700, W-900)"
        >
          <FileUploader
            v-show="!coverImage"
            :image="image"
            :onSuccess="handleSuccess"
          />
          <Cropper
            class="cropper"
            :src="image"
            v-if="coverImage != ''"
            @change="handleCropperChange"
            ref="cropper"
            :stencil-props="{
              aspectRatio: 2 / 1,
            }"
          />

          <div v-if="image">
            <p class="mt-2">Image Preview</p>

            <img v-if="image" :src="cropperImg" ref="cover" />
            <div class="flex cursor-pointer items-center my-2" v-if="image">
              <base-button type="danger" class="px-8" @click="handleRemove">
                Remove image
              </base-button>
            </div>
          </div>
          <span v-if="imageErr" class="flex justify-center small text-danger">{{
            msg.image
          }}</span>

          <div class="mt-3 mb-4">
            <p class="mb-2">Uploaded Image</p>
            <img
              class="w-1/2"
              :src="$imageURL + '/' + image2"
              alt="uploaded-image"
            />

            <base-button
              v-if="image2"
              type="danger"
              class="px-8"
              @click="handleRemove"
            >
              Remove image
            </base-button>
          </div>
        </b-form-group>
        <b-form-group label="Description">
          <quill-editor
            v-model="description"
            :options="editorOption"
            class="quill-h200px my-2"
          />
        </b-form-group>

        <div class="mb-2 w-1/3">
          <div>
            <label class="mr-4" for="date">Date:</label>
          </div>
          <el-date-picker
            v-model="date"
            type="date"
            placeholder="Pick a date"
            :default-value="new Date()"
            format="dd-MM-yyyy"
            name="date"
            required
          >
          </el-date-picker>
          <br />
          <span v-if="dateErr" class="text-center small text-danger">{{
            msg.date
          }}</span>
        </div>
        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Save</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { DatePicker } from "element-ui";

import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

import { mapState } from "vuex";
import { title } from "process";

export default {
  components: {
    FileUploader,
    Cropper,
    quillEditor,
    [DatePicker.name]: DatePicker,
  },
  data() {
    return {
      title: "",
      description: "",
      image: "",
      image2: "",
      coverImage: "",
      cropperImg: "",
      msg: {
        name: "",
        image: "",
        date: "",
      },
      editorOption: {
        theme: "snow",
      },
      date: null,
      imageErr: false,
    };
  },
  computed: {
    ...mapState("friendsUpdates", {
      selectedfriendsUpdates: "selectedfriendsUpdates",
    }),
  },

  methods: {
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    handleCropperChange(img) {
      // console.log(img);
      this.cropperImg = this.$refs.cropper.getResult().canvas.toDataURL();
      this.coverImage = this.dataURLtoFile(img.canvas.toDataURL(), "image.png");
    },
    handleSuccess(image) {
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;
        let mByte = 5 * 1048576;
        if (image.size > mByte) {
          this.$swal.fire({
            title: "File size exceeds the allowed limit!",
            // text: "Please ensure that the file size does not exceed 5MB",
            html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          return;
        }
        this.coverImage = image;
        this.readerData(image);
      }
    },

    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },

    async onSubmit() {
      if (this.date === null) {
        this.dateErr = true;
        this.msg.date = "Date is required";
        return;
      }
      if (!this.coverImage && !this.image2) {
        this.$swal.fire({
          text: "Please Select Image",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        return;
      }
      // let FormData = require("form-data");
      let data = new FormData();

      data.append("_id", this.selectedfriendsUpdates._id);
      data.append("title", this.title);
      if (this.description) data.append("description", this.description);
      if (!this.description) {
        // this.$swal.fire({
        //   text: "Description is required",
        //   confirmButtonText: "Okay",
        //   confirmButtonColor: "#830c81",
        //   showCancelButton: false,
        // });
        this.$notify.error({
          message: "Description is required  ",
          position: "top-right",
        });

        return;
      }
      //   data.append("isActive", this.isActive);
      data.append("date", this.date);
      if (this.coverImage) {
        data.append("image", this.coverImage);
      } else if (this.image2) {
        data.append("image", this.image2);
      }
      let loader = this.$loading();

      try {
        const editData = await this.$store.dispatch(
          "friendsUpdates/editFriends",
          data
        );
        if (editData.code == 200) {
          this.$router.push({ name: "friends-updates" });
          this.$swal.fire({
            text: " Data successfully updated",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
        }
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
    async init() {
      this.title = this.selectedfriendsUpdates.title;
      this.description = this.selectedfriendsUpdates.description;
      //   this.image = `${this.$imageURL}/${this.selectedfriendsUpdates.image}`;
      this.date = this.selectedfriendsUpdates.date || null;
      this.image2 = this.selectedfriendsUpdates.image;
      this.isActive = this.selectedfriendsUpdates.isActive
        ? this.selectedfriendsUpdates.isActive
        : false;
      // this.isSelected = this.selectedBlog.isSelected;
    },
    handleRemove() {
      this.image = null;
      this.image2 = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.h300px {
  height: 300px !important;
}
.imgupload {
  height: 270px !important;
}
</style>
